import { magicLinkClient, organizationClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'
import { API_URL } from './api'

/** Must match `AUTH_BASE_PATH` in apps/api/src/auth/better-auth.ts. */
export const AUTH_BASE_PATH = '/api/auth/ba'

export const authClient = createAuthClient({
  baseURL: API_URL || window.location.origin,
  basePath: AUTH_BASE_PATH,
  plugins: [magicLinkClient(), organizationClient()],
})
